import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Progress } from '../ui/progress';
import { CheckCircle, XCircle, Clock } from '@phosphor-icons/react';

const StatusRow = ({ icon: Icon, iconColor, label, displayCount, pct }) => (
  <div className="space-y-2">
    <div className="flex justify-between text-sm">
      <span className="flex items-center gap-1">
        <Icon size={14} className={iconColor} />
        {label}
      </span>
      <span className="font-medium">{displayCount}</span>
    </div>
    <Progress value={pct} className="h-2 bg-slate-100" />
  </div>
);

const ClaimsStatusOverview = ({
  claimsPaid,
  claimsPending,
  claimsDenied,
  totalClaims,
}) => {
  const paidPct = totalClaims > 0 ? (claimsPaid / totalClaims) * 100 : 0;
  const pendingPct = totalClaims > 0 ? (claimsPending / totalClaims) * 100 : 0;
  const deniedPct = totalClaims > 0 ? (claimsDenied / totalClaims) * 100 : 0;

  return (
    <Card className="border-slate-200" data-testid="ca-claims-status-overview">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Claims Status Overview</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-6">
          <StatusRow
            icon={CheckCircle}
            iconColor="text-green-600"
            label="Paid"
            displayCount={`${claimsPaid.toLocaleString()} (${paidPct.toFixed(1)}%)`}
            pct={paidPct}
          />
          <StatusRow
            icon={Clock}
            iconColor="text-amber-600"
            label="Pending"
            displayCount={claimsPending.toLocaleString()}
            pct={pendingPct}
          />
          <StatusRow
            icon={XCircle}
            iconColor="text-red-600"
            label="Denied"
            displayCount={`${claimsDenied.toLocaleString()} (${deniedPct.toFixed(1)}%)`}
            pct={deniedPct}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ClaimsStatusOverview;
